<template>
  <div class="advertising-local-tree-item">
    <v-checkbox v-if="!isAuthorizedFalse"
                :input-value="row.checked"
                :class="`advertising-local-tree-item__checkbox ${isIndeterminate ? 'underteminate' : ''}`"
                hide-details
                readonly
                :ripple="false"></v-checkbox>
    <i v-else
       class="mdi mdi-check-circle icon"></i>

    <div class="advertising-local-tree-item__label">
      <template v-if="isAparelho || isGrupoDeLocal">
        <svgicon :icon="typeIcon"
                 width="20"
                 height="20"
                 color="gray"
                 v-if="!node.isAtivo"></svgicon>
      </template>
      <i v-else
         :class="`mdi ${typeIcon} icon`"></i>

      <p>{{ node.label }}</p>

      <span class="advertising-local-tree-item__label-local"
            v-if="isLocal && node.cidade && node.estado">({{ node.cidade }} - {{ node.estado }})</span>
    </div>
  </div>
</template>

<script>
import { LOCAL_TREE_TYPE } from "@packages/util/tree/local-tree";

export default {
  props: {
    row: {
      type: Object,
      required: true,
    },
  },

  computed: {
    node() {
      return this.row.node;
    },
    isIndeterminate() {
      return this.row.partialChecked && !this.row.checked;
    },
    isAuthorizedFalse() {
      return this.node.isAuthorized === false;
    },
    isGrupoDeLocal() {
      return this.node.type === LOCAL_TREE_TYPE.GROUP;
    },
    isLocal() {
      return this.node.type === LOCAL_TREE_TYPE.LOCAL;
    },
    isAparelho() {
      return this.node.type === LOCAL_TREE_TYPE.DEVICE;
    },
    isEstabelecimento() {
      return this.node.type === LOCAL_TREE_TYPE.ESTABLISHMENT;
    },
    typeIcon() {
      if (this.isLocal) return "mdi-map-marker-outline";
      if (this.isAparelho) return "access-point";
      if (this.isEstabelecimento) return "mdi-store";
      if (this.isGrupoDeLocal) return "folder-marker-outline";

      return "";
    },
  },
};
</script>

<style lang="scss" scoped>
.advertising-local-tree-item {
  display: flex;
  align-items: center;
  min-width: 0;
  color: #707070;

  &__checkbox {
    flex: 0;
    margin: 0;
    padding: 0;
    pointer-events: none;

    &.underteminate {
      ::v-deep .v-input__control {
        i {
          color: #82b1ff !important;
          caret-color: #82b1ff !important;

          &::before {
            content: "\F375";
          }
        }
      }
    }
  }

  &__label {
    display: flex;
    align-items: center;
    min-width: 0;

    p {
      margin: 0 5px 0 0;

      user-select: none;
      font-weight: 500;
      color: #636363;

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    i,
    .svg-icon {
      display: flex;
      align-items: center;
      font-size: 20px;
      text-align: center;
      width: 20px;
      height: 20px;
      margin-right: 5px;
      flex-shrink: 0;
    }

    &-local {
      flex-shrink: 0;
    }
  }

  .icon {
    margin-right: 5px;
  }
}
</style>
